import { Wifi, ShowerHead, Tv, Briefcase, Coffee, Wind, Thermometer, ParkingCircle, Waves, Croissant } from "lucide-react";

/** Room facility keys (as delivered by /content room_types[].facilities) -> icon + labels */
export const FACILITY_META = {
  wifi: { icon: Wifi, nn: "Trådlaust nett", en: "Wireless internet" },
  shower: { icon: ShowerHead, nn: "Bad med dusj", en: "Bathroom with shower" },
  tv: { icon: Tv, nn: "TV", en: "TV" },
  desk: { icon: Briefcase, nn: "Arbeidspult", en: "Desk" },
  breakfast: { icon: Croissant, nn: "Frukostbuffé inkludert", en: "Breakfast buffet included" },
  coffee: { icon: Coffee, nn: "Kaffi og te på rommet", en: "Coffee and tea in the room" },
  hairdryer: { icon: Wind, nn: "Hårtørkar", en: "Hairdryer" },
  kettle: { icon: Thermometer, nn: "Vasskokar", en: "Kettle" },
  parking: { icon: ParkingCircle, nn: "Gratis parkering", en: "Free parking" },
  pool: { icon: Waves, nn: "Gratis bruk av bassenget (juni–august)", en: "Free use of the pool (June–August)" },
};

/** Default list used when a room type has no explicit facilities */
export const FACILITIES = ["shower", "wifi", "tv", "desk", "hairdryer", "kettle", "coffee", "breakfast"].map((k) => ({ key: k, ...FACILITY_META[k] }));

export const facilitiesFor = (rt) => {
  const keys = rt?.facilities?.length ? rt.facilities : FACILITIES.map((f) => f.key);
  return keys.filter((k) => FACILITY_META[k]).map((k) => ({ key: k, ...FACILITY_META[k] }));
};
